var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1111 0C17.6333 0 20 3.3525 20 6.48C20 12.8138 10.1778 18 10 18C9.82222 18 0 12.8138 0 6.48C0 3.3525 2.36667 0 5.88889 0C7.91111 0 9.23333 1.02375 10 1.92375C10.7667 1.02375 12.0889 0 14.1111 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.e62ab57338762ca90245de5a56412657.svg";
export { ForwardRef as ReactComponent };